module.exports = __webpack_public_path__ + "img/distance_orange.9264c116.svg";